import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { forEach } from '@angular/router/src/utils/collection';
import { GL_Child } from '../../../models/GL_Child';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { Global } from '../../global';

@Component({
  selector: 'app-import-students',
  templateUrl: './import-students.component.html',
  styleUrls: ['./import-students.component.css']
})
export class ImportStudentsComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};

  newStudents: any = {};
  ArrAccountMaps: any;
  studentMasterAcc: string;

  GL_Child: GL_Child = {
    GL_MasterCode: "",
    GL_ChildCode: "",
    GL_ChildDesc: "",
    GL_ChildDesc_en: "",
    CurrentBalance: 0,
    RecordStat: "O",
    AuthStat: "A",
    MakerID: "test",
    CheckerID: "test",
    CreateDate: new Date(),
    UDF1: '',
    UDF2: '',
    UDF3: ''
  };

  constructor(
    private global: Global,
    private UtilityService: UtilityService,
    private GL_MasterService: GL_MasterService,
    private AccountMapService: AccountMappingService,
  ) { }

  ngOnInit() {
    this.getAccountMaps();
    this.getNewStudents();
    this.getLabels();

  }

  getNewStudents() {
    this.UtilityService.getNewStudents().subscribe(response => {
      console.log(response);
      this.newStudents = response;
    })
  }

  importNewStudents() {
    console.log('inside import..');
    for (let stu in this.newStudents) {
      console.log(stu);
      this.GL_Child.GL_ChildCode = this.newStudents[stu].gL_ChildCode;
      this.GL_Child.GL_ChildDesc = this.newStudents[stu].gL_ChildDesc;
      this.GL_Child.UDF1 = this.newStudents[stu].udF1;
      this.GL_Child.GL_MasterCode = this.studentMasterAcc;
      this.GL_Child.UDF3 = this.newStudents[stu].udF3;
      this.GL_Child.UDF2 = this.newStudents[stu].udF2;
      this.GL_MasterService.AddGL_child(this.GL_Child).subscribe(response => {
        this.getNewStudents();
      });
    }
  }

  getAccountMaps() {
    this.AccountMapService.getAccountMapping('student-invoice')
      .subscribe(response => {
        if (response) {
          this.ArrAccountMaps = response;
          this.setMaps();
        }
      },
      error => console.log("error --> " + error))
  }

  setMaps() {
    this.studentMasterAcc = this.ArrAccountMaps.find((o: any) => o.component === 'student-invoice' && o.drcr === 'D' && o.trnCode === 'AAT').masterAcc;
  }

  getLabels() {
    this.UtilityService.getLabels('import-students', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
          console.log(this.global.lang);
          console.log(this.ArrLabels);
        }
      },
        error => console.log(error))
  }

  setLabels() {
    //title
    this.labels['import-students-title'] = this.ArrLabels.find((o: any) => o.key === 'import-students-title').value;

  }

}



// WEBPACK FOOTER //
// ./src/app/components/settings/import-students/import-students.component.ts